export const PROXY = 'https://nouhadcosmetics-api.onrender.com'